export var carouselLayers = [{
  id: 'Carousel',
  type: 'carouselStateChange',
  name: 'carouselStateChange',
  event: true,
  contextualize: function contextualize(params) {
    return params;
  }
}];